"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeResponse = initializeResponse;
exports.saveResponse = saveResponse;
exports.submitResponse = submitResponse;
var _type = require("./type");
var _type2 = require("../ui/type");
var _TransCustomerFeedbackAggreatorServiceClient = require("../../clients/TransCustomerFeedbackAggreatorServiceClient");
var _getFeedbackResponseInitialState = _interopRequireDefault(require("../../utils/getFeedbackResponseInitialState"));
var _FeedbackConstants = require("../../constants/FeedbackConstants");
/** @typedef {import("@amzn/coral_com-amazon-trans-feedback-tcfa-model-v-1").UserFeedback} UserFeedback */
/** @typedef {{type: string, payload: any}} Action */

function saveResponse(_ref) {
  var id = _ref.id,
    answer = _ref.answer;
  return {
    type: _type.SAVE_RESPONSE,
    payload: {
      id: id,
      answer: answer
    }
  };
}

/**
 * Init response from questions
 *
 * @param {{questionId: string, isMandatory: boolean}[]} questions
 * @returns {Action}
 */
function initializeResponse(questions) {
  return {
    type: _type.SET_STATE,
    payload: (0, _getFeedbackResponseInitialState["default"])(questions)
  };
}

/**
 * Submit response action
 *
 * @param {string} applicationId
 * @param {string} feedbackIntent
 * @param {UserFeedback} userFeedback
 * @returns {(dispatch: Function) => Promise<Action>}
 */
function submitResponse(applicationId, feedbackIntent, userFeedback, sifProfileId) {
  return function (dispatch) {
    var submitFeedbackRequest = {
      applicationId: applicationId,
      feedbackIntent: feedbackIntent,
      userFeedback: userFeedback,
      sifProfileId: sifProfileId
    };
    dispatch({
      type: _type2.IS_SUBMIT_INPROGRESS,
      payload: true
    });
    var client = (0, _TransCustomerFeedbackAggreatorServiceClient.getTransCustomerFeedbackAggreatorServiceClient)();
    return client.submitFeedback(submitFeedbackRequest).toPromise().then(function () {
      if (feedbackIntent.includes(_FeedbackConstants.CSAT_SURVEY_FEEDBACKINTENT)) {
        dispatch({
          type: _type2.IS_SURVEY_SUBMITTED,
          payload: true
        });
      }
      dispatch({
        type: _type2.SHOW_SUCCESS_NOTIFICATION
      });
      dispatch({
        type: _type2.IS_SUBMIT_INPROGRESS,
        payload: false
      });
    })["catch"](function () {
      dispatch({
        type: _type2.IS_SUBMIT_INPROGRESS,
        payload: false
      });
      dispatch({
        type: _type2.SHOW_FAILURE_NOTIFICATION
      });
    });
  };
}
//# sourceMappingURL=index.js.map